import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { downloadJSONFile } from '@commons/util/helper/download';
import {
  copy,
  forEach,
  fromJson,
  IHttpService as $IHttpService,
  isArray,
  isDefined,
  isFunction,
  isObject,
  ITimeoutService,
  toJson,
} from 'angular';
import { i18n } from 'i18next';
import { Observable } from 'rxjs';
import { Configuration, IMetricDeprecatedService, IMetricService, StorageService, MetricId, IMetricValue } from '@contact/upgrade';

export interface IWallboardService {
  familyList();

  wallboardFamilyList();

  getTeamIndicatorList();

  groupIndicatorList();

  contactSkillIndicatorList();

  contactSkillIndicatorListWithPhone();

  contactSkillQueueIndicatorList();

  campaignIndicatorList();

  flowIndicatorList();

  goalsSkillIndicatorList();

  goalsSkillIndicatorListWithPhone();

  goalsMailChannelIndicatorList();

  contactMailFlowIndicatorList();

  contactMailSkillIndicatorList();

  contactFlowIndicatorList();

  counterIndicatorList();

  serviceIndicatorList();

  csrTargetTypeList();

  contactTargetTypeList();

  goalsTargetTypeList();

  countersTargetTypeList();

  getWallboard(login?: string): Observable<any>;

  updateWallboard(wallboardJSON, wallboardId);

  resetPassword(wallboardId);

  getCurrentContent(wallboardId);

  getTeams(): Observable<any>;

  getGroups(): Observable<any>;

  getSkills(): Observable<any>;

  getMissions(): Observable<any>;

  getMediaEntryPoints(): Observable<any>;

  getChannels(): Observable<any>;

  getCounters(): Observable<any>;

  getServices(): Observable<any>;

  getDomains();

  getCustomIndicators();

  getCampaigns(flowList);

  addWallboard(wallboard);

  deleteWallboard(wallboardId);

  deleteWallboards(wallboardIds);

  duplicateWallboard(wallboardId, duplicateDto);

  addIndicator(indicator);

  updateIndicator(indicator);

  deleteIndicator(indicatorId);

  deleteIndicators(indicatorIds);

  getImage(wallboardId, imageName);

  getImages(wallboardId);

  uploadImages(formData, wallboardId);

  deleteImages(imageNameList, wallboardId);

  buildWallboardRequest(data, size, from, sortName, sortOrder);

  buildIndicatorRequest(size, from, sortName, sortOrder);

  buildWallboardIndicatorRequest(indicatorsUuid);

  execSearchRequest(object): Observable<any>;

  execWallboardRequest(json, size, from, sortName, sortOrder): Observable<any>;

  execIndicatorRequest(size, from, sortName, sortOrder): Observable<any>;

  subscribeWallboardMetrics(wallboardId, wallboardTemplate);

  formatMetricKey(indicator);

  reset();

  onUpdated(callback);

  getExternalIndicator(wallboardId, indicatorId);

  getExternalIndicators(wallboardId, wallboardTemplate);

  exportWallboard(wallboardTemplate, wallboardName);
}

export class WallboardService implements IWallboardService {
  static $inject: Array<string> = [
    '$http',
    '$i18next',
    '$timeout',
    'httpDeprecated',
    'sessionDeprecatedService',
    'configuration',
    'deprecatedMetric',
    'storage',
    'metric',
  ];

  private metricList: any[] = [];
  private metricIds: MetricId[] = [];
  private externalIndicatorIdList: any[] = [];
  private externalIndicatorIntervals: any[] = [];
  private wallboardMetrics: any = {};
  private callbacks: any[] = [];
  private inDebounce: any;

  constructor(
    private readonly $http: $IHttpService,
    private readonly $i18next: i18n,
    private readonly $timeout: ITimeoutService,
    private readonly httpDeprecated: HttpDeprecatedService,
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly configuration: Configuration,
    private readonly deprecatedMetric: IMetricDeprecatedService,
    private readonly storageService: StorageService,
    private readonly metric: IMetricService
  ) {}

  // region Wallboard entity lists
  familyList() {
    let result = this.wallboardFamilyList();
    result.push({ id: 'NUMERIC', name: 'commons:basic.numeric' });
    return result.sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  wallboardFamilyList() {
    return [
      { id: 'CSR', name: 'commons:basic.csrName' },
      { id: 'CONTACT', name: 'commons:basic.contact_header' },
      { id: 'GOALS', name: 'commons:basic.goals' },
      { id: 'COUNTERS', name: 'commons:basic.counters' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  getTeamIndicatorList() {
    return [
      {
        id: 'SUM_CSR_NOT_WORKING_TEAM_NOW', // team_nb_agent_not_working_now(teamId)
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_NOT_WORKING_TEAM_NOW',
      },
      { id: 'SUM_CSR_TASK_TEAM_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_TASK_TEAM_NOW' }, // team_nb_agent_task_now(teamId)
      { id: 'SUM_CSR_BURNT_TEAM_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_BURNT_TEAM_NOW' }, // team_nb_agent_suspended_now(teamId)
      { id: 'SUM_CSR_AVAILABLE_TEAM_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_TEAM_NOW' }, // team_nb_agent_available_now(teamId)
      { id: 'SUM_CSR_WORKING_TEAM_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_WORKING_TEAM_NOW' }, // team_nb_agent_working_now(teamId)
      { id: 'SUM_CSR_PRESENT_TEAM_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_TEAM_NOW' }, // team_nb_agent_present_now(teamId)
      { id: 'CUSTO_TEAM_RATE_EFFICIENCY', name: 'wallboard:viewIndicators.indicators.CUSTO_TEAM_RATE_EFFICIENCY' }, // team_rate_efficiency(teamId)
      {
        id: 'CUSTO_TEAM_TA_AGENT_IN_PROCESS_INCOMING_PHONE',
        name: 'wallboard:viewIndicators.indicators.CUSTO_TEAM_TA_AGENT_IN_PROCESS_INCOMING_PHONE',
      }, // team_ta_agent_in_process_channel
      {
        id: 'CUSTO_TEAM_NB_AGENT_IN_PROCESS_OUTGOING_PHONE',
        name: 'wallboard:viewIndicators.indicators.CUSTO_TEAM_NB_AGENT_IN_PROCESS_OUTGOING_PHONE',
      }, // team_nb_agent_in_process_channel_now
      {
        id: 'CUSTO_TEAM_NB_AGENT_IN_PROCESS_INCOMING_PHONE',
        name: 'wallboard:viewIndicators.indicators.CUSTO_TEAM_NB_AGENT_IN_PROCESS_INCOMING_PHONE',
      }, //team_nb_agent_in_process_channel_now
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  groupIndicatorList() {
    return [
      {
        id: 'SUM_CSR_NOT_WORKING_GROUP_NOW', // group_nb_agent_not_working_now(groupId)
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_NOT_WORKING_GROUP_NOW',
      },
      { id: 'SUM_CSR_TASK_GROUP_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_TASK_GROUP_NOW' }, // group_nb_agent_task_now(groupId)
      { id: 'SUM_CSR_BURNT_GROUP_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_BURNT_GROUP_NOW' }, // group_nb_agent_suspended_now(groupId)
      {
        id: 'SUM_CSR_AVAILABLE_GROUP_NOW', // group_nb_agent_available_now(groupId)
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_GROUP_NOW',
      },
      { id: 'SUM_CSR_WORKING_GROUP_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_WORKING_GROUP_NOW' }, // group_nb_agent_working_now(groupId)
      { id: 'SUM_CSR_PRESENT_GROUP_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_GROUP_NOW' }, // group_nb_agent_present_now(groupId)
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactSkillIndicatorList() {
    return [
      { id: 'SUM_CSR_PRESENT_SKILL_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_SKILL_NOW' },
      {
        id: 'SUM_CSR_AVAILABLE_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_SKILL_NOW',
      },
      {
        id: 'SUM_CSR_NOT_WORKING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_NOT_WORKING_SKILL_NOW',
      },
      { id: 'SUM_CSR_TASK_SKILL_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CSR_TASK_SKILL_NOW' },
      {
        id: 'SUM_CSR_POST_PROCESSING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_POST_PROCESSING_SKILL_NOW',
      },
      { id: 'TA_WAITING_SUCCESS_SKILL', name: 'wallboard:viewIndicators.indicators.TA_WAITING_SUCCESS_SKILL' },
      { id: 'TA_WAITING_GAVE_UP_SKILL', name: 'wallboard:viewIndicators.indicators.TA_WAITING_GAVE_UP_SKILL' },
      {
        id: 'TA_WAITING_NOT_PROCESSED_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_NOT_PROCESSED_SKILL',
      },
      { id: 'SUM_CTT_CREATED_SKILL_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_SKILL_NOW' },
      {
        id: 'SUM_CTT_PROCESSING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_PROCESSING_SKILL_NOW',
      },
      { id: 'SUM_CTT_CREATED_SKILL', name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_SKILL' },
      { id: 'SUM_CTT_SUCCESS_SKILL', name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_SKILL' },
      {
        id: 'SUM_CTT_NOT_PROCESSED_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_PROCESSED_SKILL',
      },
      { id: 'SUM_CTT_GAVE_UP_SKILL', name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_SKILL' },
      { id: 'SKILL_OLDER_CONTACT_WT', name: 'wallboard:viewIndicators.indicators.SKILL_OLDER_CONTACT_WT' },
      {
        id: 'SUM_CTT_GAVE_UP_IN_LESS_THAN_24S_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_IN_LESS_THAN_24S_SKILL',
      },
      {
        id: 'SUM_AVAILABLE_SLOTS_CHAT_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_AVAILABLE_SLOTS_CHAT_INCOMING_SKILL_NOW',
      },
      {
        id: 'RATE_CTT_PROCESSED_CHAT_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_CHAT_INCOMING_SKILL',
      },
      {
        id: 'TA_CTT_PROCESSING_TIME_CHAT_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_CTT_PROCESSING_TIME_CHAT_INCOMING_SKILL',
      },
      {
        id: 'SUM_CSR_WORKING_CHAT_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_WORKING_CHAT_INCOMING_SKILL_NOW',
      },
      {
        id: 'CUSTO_SKILL_NB_CONTACT_PROCESSED_IN_LESS_THAN_60_SECONDS',
        name: 'wallboard:viewIndicators.indicators.CUSTO_SKILL_NB_CONTACT_PROCESSED_IN_LESS_THAN_60_SECONDS',
      },
      {
        id: 'CUSTO_SKILL_NB_CONTACT_GAVE_UP_IN_LESS_THAN_15_SECONDS',
        name: 'wallboard:viewIndicators.indicators.CUSTO_SKILL_NB_CONTACT_GAVE_UP_IN_LESS_THAN_15_SECONDS',
      },
      {
        id: 'SUM_CTT_CREATED_CHAT_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_CHAT_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_SUCCESS_CHAT_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_CHAT_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_ANSWERED_CHAT_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_ANSWERED_CHAT_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_NOT_ANSWERED_CHAT_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_ANSWERED_CHAT_INCOMING_SKILL',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactSkillIndicatorListWithPhone() {
    return [
      ...this.contactSkillIndicatorList(),
      {
        id: 'SUM_CSR_PRESENT_PHONE_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'SUM_CSR_AVAILABLE_PHONE_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'SUM_CSR_POST_PROCESSING_PHONE_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_POST_PROCESSING_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'TA_WAITING_SUCCESS_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_SUCCESS_PHONE_INCOMING_SKILL',
      },
      {
        id: 'TA_WAITING_GAVE_UP_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_GAVE_UP_PHONE_INCOMING_SKILL',
      },
      {
        id: 'TA_WAITING_NOT_PROCESSED_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_NOT_PROCESSED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_CREATED_PHONE_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'SUM_CTT_PROCESSING_PHONE_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_PROCESSING_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'SUM_CTT_CREATED_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_SUCCESS_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_PHONE_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_NOT_PROCESSED_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_PROCESSED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'SUM_CTT_GAVE_UP_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_PHONE_INCOMING_SKILL',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactSkillQueueIndicatorList() {
    return [
      {
        id: 'skills-tuple_nb_agent_present_all_channel_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_agent_available_all_channel_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_agent_break_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_NOT_WORKING_SKILL_NOW',
      },
      { id: 'skills-tuple_nb_agent_task_now', name: 'wallboard:viewIndicators.indicators.SUM_CSR_TASK_SKILL_NOW' },
      {
        id: 'skills-tuple_nb_agent_post_processing_queue_all_channel_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_POST_PROCESSING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_ta_waiting_success_all_channel',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_SUCCESS_SKILL',
      },
      { id: 'skills-tuple_ta_waiting_gave_up', name: 'wallboard:viewIndicators.indicators.TA_WAITING_GAVE_UP_SKILL' },
      {
        id: 'skills-tuple_ta_waiting_not_processed',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_NOT_PROCESSED_SKILL',
      },
      { id: 'skills-tuple_nb_contact_created_all_channel_now', name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_SKILL_NOW' },
      {
        id: 'skills-tuple_nb_contact_processing_all_channel_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_PROCESSING_SKILL_NOW',
      },
      { id: 'skills-tuple_nb_contact_presented_all_channel', name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_SKILL' },
      { id: 'skills-tuple_nb_contact_success_all_channel', name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_SKILL' },
      {
        id: 'skills-tuple_nb_contact_not_processed_all_channel',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_PROCESSED_SKILL',
      },
      { id: 'skills-tuple_nb_contact_gave_up_all_channel', name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_SKILL' },
      { id: 'skills-tuple_tmax_contact_waiting_all_channel_now', name: 'wallboard:viewIndicators.indicators.SKILL_OLDER_CONTACT_WT' },
      {
        id: 'skills-tuple_nb_contact_gave_up_in_less_than_a_duration',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_IN_LESS_THAN_24S_SKILL',
      },
      {
        id: 'skills-tuple_slots_sum_available_now',
        name: 'wallboard:viewIndicators.indicators.SUM_AVAILABLE_SLOTS_CHAT_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_rate_contact_processed',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_CHAT_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_ta_contact_processing',
        name: 'wallboard:viewIndicators.indicators.TA_CTT_PROCESSING_TIME_CHAT_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_agent_working_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_WORKING_CHAT_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_contact_answered',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_ANSWERED_CHAT_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_contact_not_answered',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_ANSWERED_CHAT_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_agent_present_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_agent_available_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_agent_post_processing_queue_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_POST_PROCESSING_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_ta_waiting_success',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_SUCCESS_PHONE_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_ta_waiting_gave_up_channel',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_GAVE_UP_PHONE_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_ta_waiting_not_processed_channel',
        name: 'wallboard:viewIndicators.indicators.TA_WAITING_NOT_PROCESSED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_contact_waiting_channel_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_contact_processing_now',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_PROCESSING_PHONE_INCOMING_SKILL_NOW',
      },
      {
        id: 'skills-tuple_nb_contact_presented',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_contact_success',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_PHONE_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_contact_not_processed',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_PROCESSED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'skills-tuple_nb_contact_gave_up',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_PHONE_INCOMING_SKILL',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  campaignIndicatorList() {
    return [
      {
        id: 'SUM_CONTACT_UNPROCESSED_CAMPAIGN',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_UNPROCESSED_CAMPAIGN',
      },
      { id: 'RATE_PROGRESS_CAMPAIGN', name: 'wallboard:viewIndicators.indicators.RATE_PROGRESS_CAMPAIGN' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  flowIndicatorList() {
    return [
      { id: 'RATE_CTT_PROCESSED_EP', name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_EP' },
      { id: 'RATE_CTT_DISSUADED_EP', name: 'wallboard:viewIndicators.indicators.RATE_CTT_DISSUADED_EP' },
      { id: 'RATE_CTT_GAVE_UP_EP', name: 'wallboard:viewIndicators.indicators.RATE_CTT_GAVE_UP_EP' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  goalsSkillIndicatorList() {
    return [
      { id: 'RATE_CTT_PROCESSED_SKILL', name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_SKILL' },
      {
        id: 'RATE_CTT_NOT_PROCESSED_SKILL',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_NOT_PROCESSED_SKILL',
      },
      { id: 'RATE_CTT_GAVE_UP_SKILL', name: 'wallboard:viewIndicators.indicators.RATE_CTT_GAVE_UP_SKILL' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  goalsSkillIndicatorListWithPhone() {
    return [
      ...this.goalsSkillIndicatorList(),
      {
        id: 'RATE_CTT_PROCESSED_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'RATE_CTT_NOT_PROCESSED_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_NOT_PROCESSED_PHONE_INCOMING_SKILL',
      },
      {
        id: 'RATE_CTT_GAVE_UP_PHONE_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_GAVE_UP_PHONE_INCOMING_SKILL',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  goalsMailChannelIndicatorList() {
    return [
      {
        id: 'SUM_CONTACT_MAIL_INCOMING_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_INCOMING_SKILL',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactMailFlowIndicatorList() {
    return [
      {
        id: 'SUM_CONTACT_MAIL_CLOSED_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_CLOSED_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_EMAIL_CLOSED_WITHOUT_ANSWER_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_CLOSED_WITHOUT_ANSWER_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_EMAIL_CLOSE_WITH_AT_LEAST_ONE_ANSWER_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_CLOSE_WITH_AT_LEAST_ONE_ANSWER_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_EMAIL_CLOSE_AND_FORWARD_TO_EXTERNAL_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_CLOSE_AND_FORWARD_TO_EXTERNAL_BY_ENTRY_POINT',
      },
      {
        id: 'TA_CONTACT_EMAIL_CLOSED_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.TA_CONTACT_EMAIL_CLOSED_BY_ENTRY_POINT',
      },
      {
        id: 'TA_CONTACT_EMAIL_REPLIED_AND_CLOSED_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.TA_CONTACT_EMAIL_REPLIED_AND_CLOSED_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_WAITING_EMAILS_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_WAITING_EMAILS_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_EMAIL_SUPPORTED_BY_ENTRY_POINT_STOCK',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_SUPPORTED_BY_ENTRY_POINT_STOCK',
      },
      {
        id: 'SUM_CONTACT_EMAIL_IN_APPROVAL_BY_ENTRY_POINT_STOCK',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_IN_APPROVAL_BY_ENTRY_POINT_STOCK',
      },
      {
        id: 'SUM_CONTACT_EMAIL_APPROVED_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_APPROVED_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_EMAIL_NON_APPROVED_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_NON_APPROVED_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_TO_AN_AGENT_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_TO_AN_AGENT_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_TO_A_SUP_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_TO_A_SUP_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_TO_SKILL_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_TO_SKILL_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_EMAIL_FORWARDED_TO_EXTERNAL_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_FORWARDED_TO_EXTERNAL_BY_ENTRY_POINT',
      },
      {
        id: 'SUM_CONTACT_ASSISTANCE_REQUEST_BY_ENTRY_POINT',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_ASSISTANCE_REQUEST_BY_ENTRY_POINT',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactMailSkillIndicatorList() {
    return [
      {
        id: 'SUM_CSR_PRESENT_SKILL_MAIL_INCOMING_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_PRESENT_SKILL_MAIL_INCOMING_NOW',
      },
      {
        id: 'SUM_CSR_AVAILABLE_MAIL_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_AVAILABLE_MAIL_INCOMING_SKILL_NOW',
      },
      {
        id: 'SUM_CSR_TASK_SKILL_MAIL_INCOMING_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CSR_TASK_SKILL_MAIL_INCOMING_NOW',
      },
      {
        id: 'SUM_CTT_CREATED_MAIL_INCOMING_SKILL_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_MAIL_INCOMING_SKILL_NOW',
      },
      {
        id: 'SUM_CONTACT_MAIL_CLOSED_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_CLOSED_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_EMAIL_CLOSED_WITHOUT_ANSWER_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_CLOSED_WITHOUT_ANSWER_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_EMAIL_CLOSE_WITH_AT_LEAST_ONE_ANSWER_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_CLOSE_WITH_AT_LEAST_ONE_ANSWER_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_EMAIL_CLOSE_AND_FORWARD_TO_EXTERNAL_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_CLOSE_AND_FORWARD_TO_EXTERNAL_BY_SKILL',
      },
      {
        id: 'TA_CONTACT_EMAIL_CLOSED_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_CONTACT_EMAIL_CLOSED_BY_SKILL',
      },
      {
        id: 'TA_CONTACT_EMAIL_REPLIED_AND_CLOSED_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.TA_CONTACT_EMAIL_REPLIED_AND_CLOSED_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_WAITING_EMAILS_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_WAITING_EMAILS_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_EMAIL_SUPPORTED_BY_SKILL_STOCK',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_SUPPORTED_BY_SKILL_STOCK',
      },
      {
        id: 'SUM_CONTACT_EMAIL_IN_APPROVAL_BY_SKILL_STOCK',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_IN_APPROVAL_BY_SKILL_STOCK',
      },
      {
        id: 'SUM_CONTACT_EMAIL_APPROVED_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_APPROVED_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_EMAIL_NON_APPROVED_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_NON_APPROVED_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_TO_AN_AGENT_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_TO_AN_AGENT_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_TO_A_SUP_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_TO_A_SUP_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_MAIL_TRANSFERRED_TO_SKILLS_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_MAIL_TRANSFERRED_TO_SKILLS_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_EMAIL_FORWARDED_TO_EXTERNAL_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_EMAIL_FORWARDED_TO_EXTERNAL_BY_SKILL',
      },
      {
        id: 'SUM_CONTACT_ASSISTANCE_REQUEST_BY_SKILL',
        name: 'wallboard:viewIndicators.indicators.SUM_CONTACT_ASSISTANCE_REQUEST_BY_SKILL',
      },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactFlowIndicatorList() {
    return [
      { id: 'SUM_CTT_PROCESSING_EP_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CTT_PROCESSING_EP_NOW' },
      { id: 'SUM_CTT_WAITING_EP_NOW', name: 'wallboard:viewIndicators.indicators.SUM_CTT_WAITING_EP_NOW' },
      { id: 'SUM_CTT_CREATED_EP', name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_EP' },
      { id: 'SUM_CTT_SUCCESS_EP', name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_EP' },
      { id: 'SUM_CTT_GAVE_UP_EP', name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_EP' },
      { id: 'SUM_CTT_DISSUADED_EP', name: 'wallboard:viewIndicators.indicators.SUM_CTT_DISSUADED_EP' },
      { id: 'TA_WAITING_GAVE_UP_EP', name: 'wallboard:viewIndicators.indicators.TA_WAITING_GAVE_UP_EP' },
      { id: 'TA_WAITING_SUCCESS_EP', name: 'wallboard:viewIndicators.indicators.TA_WAITING_SUCCESS_EP' },
      { id: 'TA_WAITING_DISSUADED_EP', name: 'wallboard:viewIndicators.indicators.TA_WAITING_DISSUADED_EP' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  counterIndicatorList() {
    return [{ id: 'VISIT_NUMBER', name: 'wallboard:viewIndicators.indicators.VISIT_NUMBER' }].sort((a, b) =>
      this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name))
    );
  }

  serviceIndicatorList() {
    return [
      { id: 'SUM_CTT_CREATED_SERVICE', name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_SERVICE' },
      { id: 'SUM_CTT_SUCCESS_SERVICE', name: 'wallboard:viewIndicators.indicators.SUM_CTT_SUCCESS_SERVICE' },
      {
        id: 'SUM_CTT_NOT_PROCESSED_SERVICE',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_NOT_PROCESSED_SERVICE',
      },
      { id: 'SUM_CTT_GAVE_UP_SERVICE', name: 'wallboard:viewIndicators.indicators.SUM_CTT_GAVE_UP_SERVICE' },
      {
        id: 'SUM_CTT_CREATED_SERVICE_NOW',
        name: 'wallboard:viewIndicators.indicators.SUM_CTT_CREATED_SERVICE_NOW',
      },
      { id: 'RATE_CTT_PROCESSED_SERVICE', name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_SERVICE' },
      {
        id: 'RATE_CTT_PROCESSED_IN_LESS_THAN_120S_SERVICE',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_IN_LESS_THAN_120S_SERVICE',
      },
      {
        id: 'RATE_CTT_PROCESSED_LAST_15_MIN_SERVICE',
        name: 'wallboard:viewIndicators.indicators.RATE_CTT_PROCESSED_LAST_15_MIN_SERVICE',
      },
      { id: 'SERVICE_OLDER_CONTACT_WT', name: 'wallboard:viewIndicators.indicators.SERVICE_OLDER_CONTACT_WT' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  csrTargetTypeList() {
    return [
      { id: 'TEAM', name: 'commons:basic.team' },
      { id: 'GROUP', name: 'commons:basic.group' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  contactTargetTypeList() {
    return [
      { id: 'FLOW', name: 'commons:basic.flow' },
      { id: 'SKILL', name: 'commons:basic.skill' },
      { id: 'SKILLS_QUEUE', name: 'commons:basic.skillsQueue' },
      { id: 'CAMPAIGN', name: 'commons:basic.campaign' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  goalsTargetTypeList() {
    return [
      { id: 'FLOW', name: 'commons:basic.flow' },
      { id: 'SKILL', name: 'commons:basic.skill' },
      { id: 'CHANNEL', name: 'commons:basic.channel' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  countersTargetTypeList() {
    return [
      { id: 'COUNTER', name: 'commons:basic.simple' },
      { id: 'SERVICE', name: 'commons:basic.service' },
    ].sort((a, b) => this.$i18next.t(a.name).localeCompare(this.$i18next.t(b.name)));
  }

  // endregion

  // region Web services
  getWallboard(login?: string): Observable<any> {
    if (login === undefined) {
      login = this.storageService.get('wallboardAutoLogin', false).getOrElse(this.sessionDeprecatedService.getProfile().login);
    }
    return this.httpDeprecated.asObservable().get('V2/protected/wallboard', [login || '']);
  }

  updateWallboard(wallboardJSON, wallboardId) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withConfig(config).withData(wallboardJSON).put('V2/protected/wallboard', [wallboardId]);
  }

  resetPassword(wallboardId) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated
      .asPromise()
      .withConfig(config)
      .withData('')
      .put('V2/protected/wallboard/' + wallboardId + '/resetPassword');
  }

  getCurrentContent(wallboardId) {
    return this.httpDeprecated.asPromise().get('V2/protected/plannedcontent/current/' + wallboardId);
  }

  getTeams(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/teams/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getGroups(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/groups/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getSkills(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/skills/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getMissions(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/missions/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getMediaEntryPoints(): Observable<any> {
    return this.httpDeprecated.asObservable().get('V2/protected/wallboard/mediaEntryPoints');
  }

  getChannels(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/channels/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getCounters(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/counters/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getServices(): Observable<any> {
    return this.httpDeprecated
      .asObservable()
      .get('V2/protected/wallboard/services/domain', [this.sessionDeprecatedService.getProfile().domainId]);
  }

  getDomains() {
    return this.httpDeprecated.asPromise().get('V2/protected/wallboard/domains');
  }

  getCustomIndicators() {
    return this.httpDeprecated.asPromise().get('V2/protected/wallboard/indicators');
  }

  getCampaigns(flowList) {
    if (this.configuration.campaignBaseUrl != null && this.configuration.campaignBaseUrl !== '') {
      let streamIds: any[] = [];
      if (flowList != null && flowList.length > 0) {
        forEach(flowList, flow => {
          if (flow.media.mediaType === 'PHONE' && flow.media.direction === 'OUTGOING') {
            streamIds.push({
              streamUuid: flow.uuid,
            });
          }
        });
      }
      return this.$http.post(this.configuration.campaignBaseUrl + '/protected/campaign/stream', toJson(streamIds));
    }
    return [];
  }

  addWallboard(wallboard) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withData(wallboard).withConfig(config).post('V2/protected/wallboard');
  }

  deleteWallboard(wallboardId) {
    return this.httpDeprecated.asPromise().delete('V2/protected/wallboard', [wallboardId]);
  }

  deleteWallboards(wallboardIds) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withData(wallboardIds).withConfig(config).post('V2/protected/wallboard/delete');
  }

  duplicateWallboard(wallboardId, duplicateDto) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated
      .asPromise()
      .withData(duplicateDto)
      .withConfig(config)
      .post('V2/protected/wallboard/' + wallboardId + '/duplicate');
  }

  addIndicator(indicator) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withData(indicator).withConfig(config).post('V2/protected/wallboard/indicators');
  }

  updateIndicator(indicator) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated
      .asPromise()
      .withData(indicator)
      .withConfig(config)
      .put('V2/protected/wallboard/indicators', [indicator.uuid]);
  }

  deleteIndicator(indicatorId) {
    return this.httpDeprecated.asPromise().delete('V2/protected/wallboard/indicators', [indicatorId]);
  }

  deleteIndicators(indicatorIds) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asPromise().withData(indicatorIds).withConfig(config).post('V2/protected/wallboard/indicators/delete');
  }

  getImage(wallboardId, imageName) {
    return this.httpDeprecated.asPromise().get('V2/protected/wallboard/' + wallboardId + '/images/' + imageName);
  }

  getImages(wallboardId) {
    let config = {
      headers: {
        Accept: 'multipart/form-data',
      },
    };
    return this.httpDeprecated
      .asPromise()
      .withConfig(config)
      .get('V2/protected/wallboard/' + wallboardId + '/images');
  }

  uploadImages(formData, wallboardId) {
    let config = {
      headers: {
        'Content-Type': undefined,
      },
    };
    formData.append('wallboardId', wallboardId);
    return this.httpDeprecated.asPromise().withData(formData).withConfig(config).post('V2/protected/wallboard/images');
  }

  deleteImages(imageNameList, wallboardId) {
    let config = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };
    return this.httpDeprecated
      .asPromise()
      .withData(imageNameList)
      .withConfig(config)
      .post('V2/protected/wallboard/' + wallboardId + '/images/delete');
  }

  // endregion

  // region Elastic search
  buildWallboardRequest(data, size, from, sortName, sortOrder) {
    let sortField = {};
    sortField[sortName || 'name.keyword'] = { order: sortOrder || 'asc' };
    let query: any = {
      types: ['wallboard'],
      from: from,
      size: size,
      query: {
        terms: { uuid: this.sessionDeprecatedService.getProfile().visibleWallboard },
      },
      sort: [sortField],
    };
    if (data.domain.uuid != null) {
      query.query = {
        bool: {
          must: {
            terms: { uuid: this.sessionDeprecatedService.getProfile().visibleWallboard },
          },
          filter: {
            bool: {
              must: [
                {
                  term: {
                    'domainName.keyword': data.domain.name,
                  },
                },
              ],
            },
          },
        },
      };
    }
    return query;
  }

  buildIndicatorRequest(size, from, sortName, sortOrder) {
    let sortField = {};
    sortField[sortName || 'name.keyword'] = { order: sortOrder || 'asc' };
    return {
      types: ['indicator'],
      from: from,
      size: size,
      query: {
        match_all: {},
      },
      sort: [sortField],
    };
  }

  buildWallboardIndicatorRequest(indicatorsUuid) {
    return {
      types: ['indicator'],
      from: 0,
      size: 1000,
      query: {
        terms: { uuid: indicatorsUuid },
      },
    };
  }

  execSearchRequest(object): Observable<any> {
    let config = {
      headers: {
        Accept: 'application/json; charset=UTF-8',
        'Content-Type': 'text/plain; charset=UTF-8',
      },
    };
    return this.httpDeprecated.asObservable().withData(object).withConfig(config).post('protected/search/searchOnSeveralTypes');
  }

  execWallboardRequest(json, size, from, sortName, sortOrder): Observable<any> {
    let query = this.buildWallboardRequest(json, size, from, sortName, sortOrder);
    return this.execSearchRequest(JSON.stringify(query));
  }

  execIndicatorRequest(size, from, sortName, sortOrder): Observable<any> {
    let query = this.buildIndicatorRequest(size, from, sortName, sortOrder);
    return this.execSearchRequest(JSON.stringify(query));
  }

  // endregion

  // region Metrics
  private notifyUpdated() {
    // Add debounce to avoid calling the callback too much
    // because when data sends a list of metric, the metric service calls the callback foreach metric
    this.$timeout.cancel(this.inDebounce);
    this.inDebounce = this.$timeout(() => {
      this.callbacks.forEach(callback => callback(this.wallboardMetrics));
    }, 500);
  }

  private metricsCallBack(metricValues) {
    if (isArray(metricValues)) {
      metricValues.forEach(metricValue => {
        for (let metricName in metricValue) {
          let key = metricValue.entityId + '@' + metricName;
          if (isDefined(this.wallboardMetrics[key])) {
            this.wallboardMetrics[key] = metricValue[metricName];
          }
        }
      });
      this.notifyUpdated();
    }
  }

  private metricCallBack(metricValue: IMetricValue) {
    if (isDefined(this.wallboardMetrics[metricValue.documentId])) {
      this.wallboardMetrics[metricValue.documentId] = metricValue.value;
    }
    this.notifyUpdated();
  }

  formatMetricKey(indicator) {
    return (
      indicator.target
        .map(t => t.uuid)
        .sort()
        .join() +
      '@' +
      indicator.indicator
    );
  }

  private addMetricId(indicator) {
    const metricId = MetricId.of(indicator.indicator).withIds(indicator.target.map(t => t.uuid));
    metricId.withDocumentId(this.formatMetricKey(indicator));
    // channel
    if (
      indicator.indicator === 'skills-tuple_nb_agent_present_now' ||
      indicator.indicator === 'skills-tuple_nb_agent_available_now' ||
      indicator.indicator === 'skills-tuple_nb_agent_post_processing_queue_now' ||
      indicator.indicator === 'skills-tuple_ta_waiting_success' ||
      indicator.indicator === 'skills-tuple_ta_waiting_gave_up_channel' ||
      indicator.indicator === 'skills-tuple_ta_waiting_not_processed_channel' ||
      indicator.indicator === 'skills-tuple_nb_contact_waiting_channel_now' ||
      indicator.indicator === 'skills-tuple_nb_contact_presented' ||
      indicator.indicator === 'skills-tuple_nb_contact_processing_now' ||
      indicator.indicator === 'skills-tuple_nb_contact_success' ||
      indicator.indicator === 'skills-tuple_nb_contact_not_processed' ||
      indicator.indicator === 'skills-tuple_nb_contact_gave_up'
    ) {
      metricId.addLiteralParam('PHONE').addLiteralParam('INCOMING');
    } else if (
      indicator.indicator === 'skills-tuple_slots_sum_available_now' ||
      indicator.indicator === 'skills-tuple_rate_contact_processed' ||
      indicator.indicator === 'skills-tuple_ta_contact_processing' ||
      indicator.indicator === 'skills-tuple_nb_agent_working_now' ||
      indicator.indicator === 'skills-tuple_nb_contact_answered' ||
      indicator.indicator === 'skills-tuple_nb_contact_not_answered'
    ) {
      metricId.addLiteralParam('CHAT').addLiteralParam('INCOMING');
    }
    // duration
    if (indicator.indicator === 'skills-tuple_nb_contact_gave_up_in_less_than_a_duration') {
      metricId.addDurationParam(24, 0);
    }
    // reset hour
    if (indicator.indicator.slice(-3) !== 'now') {
      metricId.since(0);
    }
    this.metricIds.push(metricId);
  }

  private buildMetricList(wallboardTemplate) {
    this.metricList = [];
    this.metricIds = [];
    wallboardTemplate.forEach(template => {
      if (template.type === 'INDICATOR' && template.array !== undefined) {
        template.array.forEach(indicator => {
          if (indicator.type === 'NORMAL') {
            if (!isArray(indicator.target)) {
              if (this.metricList.indexOf(indicator.target + '@' + indicator.indicator) === -1) {
                this.metricList.push(indicator.target + '@' + indicator.indicator);
              }
            } else {
              this.addMetricId(indicator);
            }
          } else if (indicator.type === 'CUSTOM') {
            indicator.properties.forEach(property => {
              if (
                isObject(property) &&
                property.target !== undefined &&
                !isArray(property.target) &&
                this.metricList.indexOf(property.target + '@' + property.indicator) === -1
              ) {
                this.metricList.push(property.target + '@' + property.indicator);
              } else if (isArray(property.target)) {
                this.addMetricId(property);
              }
            });
          } else if (indicator.type === 'EXTERNAL') {
            this.externalIndicatorIdList.push(indicator.id);
          }
        });
      }
    });
  }

  private buildWallboardMetrics() {
    this.wallboardMetrics = {};
    this.metricList.forEach(metric => (this.wallboardMetrics[metric] = 0));
    this.metricIds.forEach(metricId => (this.wallboardMetrics[metricId.documentId] = 0));
    this.externalIndicatorIdList.forEach(id => (this.wallboardMetrics[id] = 0));
  }

  subscribeWallboardMetrics(wallboardId, wallboardTemplate) {
    this.buildMetricList(wallboardTemplate);
    this.buildWallboardMetrics();
    this.deprecatedMetric.subscribeWithList(this.metricList, values => this.metricsCallBack(values), true);
    this.metric.subscribe(this.metricIds, value => this.metricCallBack(value));
    this.getExternalIndicators(wallboardId, wallboardTemplate);
  }

  reset() {
    if (isArray(this.metricList)) {
      this.deprecatedMetric.unsubscribeWithList(this.metricList, values => this.metricsCallBack(values));
      this.metric.unsubscribe(this.metricIds);
      this.callbacks = [];
      this.metricList = [];
      this.metricIds = [];
      this.wallboardMetrics = {};
    }
  }

  onUpdated(callback) {
    if (isFunction(callback) && this.callbacks.indexOf(callback) < 0) {
      this.callbacks.push(callback);
    }
  }

  // endregion

  // region External indicators
  getExternalIndicator(wallboardId, indicatorId) {
    let config = {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
      },
    };
    return this.httpDeprecated
      .asPromise()
      .withConfig(config)
      .get('V2/protected/wallboard/' + wallboardId + '/externalIndicator/' + indicatorId);
  }

  getExternalIndicators(wallboardId, wallboardTemplate) {
    this.externalIndicatorIntervals.forEach(interval => clearInterval(interval));
    this.externalIndicatorIntervals = [];
    wallboardTemplate.forEach(template => {
      if (template.type === 'INDICATOR' && template.array !== undefined) {
        template.array.forEach(indicator => {
          if (indicator.type === 'EXTERNAL') {
            let interval = indicator.refreshMinutes * 60000 + indicator.refreshSeconds * 1000;
            if (interval == null || isNaN(interval) || interval < 5000) {
              interval = 5000;
            }
            this.externalIndicatorIntervals.push(
              setInterval(() => {
                this.getExternalIndicator(wallboardId, indicator.id).then(response => {
                  if (response.status !== 204 && isObject(response.data)) {
                    if (isObject(response.data.data)) {
                      this.wallboardMetrics[indicator.id] = response.data.data.value;
                    } else {
                      this.wallboardMetrics[indicator.id] = fromJson(response.data.data).value;
                    }
                  }
                });
                this.notifyUpdated();
              }, interval)
            );
          }
        });
      }
    });
  }

  // endregion

  // region export
  exportWallboard(wallboardTemplate, wallboardName) {
    let emptyTemplate = copy(wallboardTemplate);
    emptyTemplate.forEach(box => {
      if (box.type === 'META') {
        box.backgroundImage = '';
      } else if (box.type === 'INDICATOR') {
        box.array.forEach(indicator => {
          indicator.indicator = '';
          indicator.target = '';
        });
        delete box.sequenceIndex;
        delete box.sequence;
      } else if (box.type === 'IMAGE') {
        box.images = [];
        delete box.slideshow;
        delete box.slideshowIndex;
      }
    });
    downloadJSONFile(toJson(emptyTemplate), wallboardName);
  }

  // endregion
}

export default 'wallboardService';
